import { ControlModeTemplateField } from '@src/types/ControlModes';

/**
 * Helper function to handle deletion of fields and settings
 */
export const handleItemDeletion = (
  deleteItemType: 'field' | 'setting',
  itemToDelete: ControlModeTemplateField | string | null,
  deleteField: (field: ControlModeTemplateField) => void,
  deleteSetting: (controllerField: string) => void,
): void => {
  if (deleteItemType === 'field' && itemToDelete) {
    // Check if itemToDelete is a ControlModeTemplateField
    if (typeof itemToDelete !== 'string') {
      deleteField(itemToDelete);
    }
  } else if (deleteItemType === 'setting' && itemToDelete) {
    // Check if itemToDelete is a ControlModeTemplateField
    if (typeof itemToDelete !== 'string') {
      deleteSetting(itemToDelete.controllerField);
    } else {
      deleteSetting(itemToDelete);
    }
  }
};
